import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { MessageSquare, X, ExternalLink } from "lucide-react";

export default function NotificationBanner() {
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState({});

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      api
        .get("/me/notifications")
        .then(({ data }) => { if (!cancelled) setItems(data || []); })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const unread = items.filter((n) => !n.read && !hidden[n.id]);
  if (unread.length === 0) return null;

  const dismiss = async (id) => {
    setHidden((h) => ({ ...h, [id]: true }));
    try {
      await api.post(`/me/notifications/${id}/read`);
    } catch { /* silent */ }
  };

  return (
    <div className="space-y-2 mb-4" data-testid="notification-banner">
      {unread.slice(0, 3).map((n) => (
        <div
          key={n.id}
          className="rounded-2xl p-3 border-2 flex items-start gap-3"
          style={{ borderColor: "#FFD708", background: "#FFF7ED" }}
          data-testid={`notification-${n.id}`}
        >
          <div className="h-8 w-8 rounded-lg flex items-center justify-center shrink-0" style={{ background: "#FFD708", color: "#13A699" }}>
            <MessageSquare className="h-4 w-4" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-sm" style={{ color: "#13A699" }}>{n.title}</div>
            <div className="text-xs mt-0.5" style={{ color: "#13A69988" }}>{n.body}</div>
            {n.link && (
              <Link
                to={n.link.startsWith("http") ? "#" : n.link}
                onClick={(e) => {
                  if (n.link.startsWith("http")) {
                    e.preventDefault();
                    window.location.href = n.link;
                  }
                }}
                className="mt-1 inline-flex items-center gap-1 text-xs font-bold hover:underline"
                style={{ color: "#13A699" }}
                data-testid={`notification-link-${n.id}`}
              >
                Take action <ExternalLink className="h-3 w-3" />
              </Link>
            )}
          </div>
          <button
            onClick={() => dismiss(n.id)}
            className="p-1 rounded-full hover:bg-black/5 shrink-0"
            aria-label="Dismiss"
            data-testid={`notification-dismiss-${n.id}`}
          >
            <X className="h-4 w-4" style={{ color: "#13A69988" }} />
          </button>
        </div>
      ))}
    </div>
  );
}
